import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import {
  ExternalInvitation,
  Status,
} from '../entities/external-invitation.entity';
import { getExternalInvitations } from './get-external-invitations.action';

export type ChangeInvitationStatusParams = {
  invitation: ExternalInvitation;
  status: Status;
};

export const changeInvitationStatus = createAppAsyncThunk(
  'externalInvitation/changeInvitationStatus',
  async (
    { invitation, status }: ChangeInvitationStatusParams,
    { extra: { externalInvitationGateway, snackbarGateway }, dispatch },
  ) => {
    try {
      await externalInvitationGateway.changeInvitationStatus(
        invitation.id,
        status,
      );
      showSnackbarSuccess(snackbarGateway);
      dispatch(getExternalInvitations({ projectId: invitation.projectId }));
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('ChangeInvitationStatus.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('ChangeInvitationStatus.Message.error'));
}
